<template>
  <div class="date-selection-row" :class="customClass">
    <div class="btn-date-today-wrap">
      <button
        type="button"
        class="btn-date-today"
        :class="{
          'is-current': selectedDate === currentDate,
          'is-past-shows': pastShowsActive,
        }"
        @click="goToToday"
      >
        Today
      </button>
      <ul v-if="isPastShowsMenuOpen" class="past-shows-menu">
        <li
          class="past-shows-menu-item"
          :class="{ active: pastShowsActive }"
          @click="onSelectPastShows(true)"
        >
          Show Past Shows
        </li>
        <li
          class="past-shows-menu-item"
          :class="{ active: !pastShowsActive }"
          @click="onSelectPastShows(false)"
        >
          Show Current Shows
        </li>
      </ul>
    </div>
    <div class="date-selection-container">
      <slick ref="slick1" :options="dateSelectionSlider">
        <div v-for="(dateLoop, loop) in dates" :key="loop">
          <div
            v-on:click="onChangeTab(dateLoop)"
            :class="[
              'date-slider-box',
              selectedDate == dateLoop
                ? 'active cursor-pointer'
                : allowPastBooking == 'Y'
                ? 'cursor-pointer'
                : new Date(currentDate) > new Date(dateLoop)
                ? 'cursor-pointer'
                : 'cursor-pointer',
              selectedDate == dateLoop && selectedDate != currentDate
                ? 'date-not-today-blink'
                : '',
            ]"
          >
            <div class="text-center">
              <span>{{ dateLoop }}</span>
              <div class="lh-1" style="font-size:80%">
                {{ dateLoop | dayparse }}
              </div>
            </div>
          </div>
        </div>
      </slick>
    </div>
  </div>
</template>

<script>
  import Slick from "vue-slick";
  import moment from "moment";
  import { EventBus } from "@/main";

  export default {
    props: {
      childComponents: {
        type: Object,
      },
      customClass: {
        type: String,
        default: "",
      },
      dateSelectionSlider: {
        type: Object,
        default: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 1,
        },
      },
      onChangeTab: {
        type: Function,
      },

      selectedTabIndex: {
        type: Number,
        default: 0,
      },
      // when true, clicking "Today" while today is already selected opens the
      // past shows option instead of doing nothing
      enablePastShows: {
        type: Boolean,
        default: false,
      },
      pastShowsActive: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Slick,
    },
    data() {
      return {
        currentDate: "",
        cinema_id: "",
        isPastShowsMenuOpen: false,
      };
    },
    beforeMount() {},
    mounted() {
      this.currentDate = moment().format("DD-MM-YYYY");
      document.addEventListener("click", this.onDocumentClick);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.onDocumentClick);
    },
    watch: {
      selectedTabIndex(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(2, true);
          });
        }
      },
    },
    computed: {
      dates() {
        if (this.$refs && this.$refs.slick1) {
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(2, true);
          });
        }
        return this.childComponents.getDatesArray;
      },
      allowPastBooking() {
        return "N";
      },
      selectedDate() {
        if (this.childComponents.isSlideSlick) {
          let getDateIndex = this.childComponents.getDatesArray.findIndex(
            (dateIndex) => {
              return dateIndex == this.childComponents.SELECTED_DATE;
            }
          );
          this.$refs.slick1.goTo(getDateIndex, true);
        }
        this.childComponents.isSlideSlick = false;
        return this.childComponents.SELECTED_DATE;
      },
    },
    methods: {
      goToToday() {
        if (!this.currentDate) {
          this.currentDate = moment().format("DD-MM-YYYY");
        }
        if (this.selectedDate === this.currentDate) {
          if (this.enablePastShows) {
            this.isPastShowsMenuOpen = !this.isPastShowsMenuOpen;
          }
          return;
        }
        this.isPastShowsMenuOpen = false;
        this.childComponents.isSlideSlick = true;
        if (typeof this.onChangeTab === "function") {
          this.onChangeTab(this.currentDate);
        }
      },
      onSelectPastShows(status) {
        this.isPastShowsMenuOpen = false;
        if (status === this.pastShowsActive) {
          return;
        }
        this.$emit("toggle-past-shows", status);
      },
      onDocumentClick(event) {
        if (!this.isPastShowsMenuOpen) {
          return;
        }
        if (this.$el && !this.$el.contains(event.target)) {
          this.isPastShowsMenuOpen = false;
        }
      },
    },
  };
</script>

<style>
  .pointer-none {
    cursor: no-drop;
    pointer-events: none;
  }

  .width97 {
    width: 95% !important;
  }

  .date-selection-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
  }

  .date-selection-row .date-selection-container {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
    width: auto;
  }

  .btn-date-today-wrap {
    position: relative;
    flex-shrink: 0;
  }

  .past-shows-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 1050;
    min-width: 165px;
    margin: 0;
    padding: 4px 0;
    list-style: none;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: var(--posGlobalRadius);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .past-shows-menu-item {
    padding: 8px 14px;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
  }

  .past-shows-menu-item:hover {
    background: #f2f6ff;
  }

  .past-shows-menu-item.active {
    color: var(--blue);
    font-weight: 600;
  }

  .btn-date-today {
    flex-shrink: 0;
    height: 40px;
    padding: 0 14px;
    border: 1px solid var(--blue);
    background: #fff;
    color: var(--blue);
    border-radius: var(--posGlobalRadius);
    font-weight: 600;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s, color 0.2s;
  }

  .btn-date-today:hover {
    background: var(--blue);
    color: #fff;
  }

  .btn-date-today.is-current {
    background: var(--blue);
    color: #fff;
  }

  .btn-date-today.is-past-shows {
    background: #ff9800;
    border-color: #ff9800;
    color: #fff;
  }

  .date-slider-box.date-not-today-blink {
    animation: date-not-today-blink 1s ease-in-out infinite;
    background-color: rgba(255, 152, 0, 0.18);
    border-bottom-color: #ff9800;
    color: #e65100;
  }

  @keyframes date-not-today-blink {
    0%,
    100% {
      opacity: 1;
      background-color: rgba(255, 152, 0, 0.28);
      box-shadow: inset 0 0 0 1px rgba(255, 152, 0, 0.45);
    }
    50% {
      opacity: 0.55;
      background-color: rgba(255, 152, 0, 0.08);
      box-shadow: inset 0 0 0 1px transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/posDateSlider.vue